import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthenticationService } from '../../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../../core/services/authfake.service';

import { OwlOptions } from 'ngx-owl-carousel-o';
import { ActivatedRoute, Router } from '@angular/router';
import { first, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { UserProfileService } from 'src/app/core/services/user.service';
import { LogsService } from '../../../core/services/logs.service';
import { detectBrowserName, Decrypt, Encrypt } from '../../../pages/functions/functions';
import Swal from 'sweetalert2';
import { SettingsService } from '../../../core/services/settings.service';
import { EventosService } from '../../../core/services/eventos.service';
import moment from 'moment';
import { AuditService } from 'src/app/core/services/audit.service';
import { InactivityService } from 'src/app/core/services/inactivity.service';
@Component({
  selector: 'app-login2',
  templateUrl: './login2.component.html',
  styleUrls: ['./login2.component.scss']
})
/**
 * Login-2 component
 */
export class Login2Component implements OnInit {
  cargando: boolean = true;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserProfileService,
    private logService: LogsService,
    private settingsService: SettingsService,
    private eventosService: EventosService,
    private auditService: AuditService,
    private inactivityService: InactivityService) {
    // window.location.reload()
    // this.getSettings();
  }
  loginForm!: FormGroup;
  logo_img!: any;
  submitted = false;
  error = '';
  showerror: boolean = false;
  returnUrl!: string;
  isLoading = false;
  button = 'Iniciar Sesión';
  fieldTextType!: boolean;
  session!: any;
  // set the currenr year
  year: number = new Date().getFullYear();
  isWhiteLogo = false;
  showPassword = false;
  locationId: number | null = null;
  scope: 'location' | 'corporate' = 'location';
  logoLoaded = false;
  loading = false;
  ngOnInit(): void {

    // ==========================================================
    // OBTENER CONTEXTO DEL LOGIN
    // ==========================================================

    this.route.queryParamMap.subscribe(params => {

      const locationIdParam = params.get('locationId');
      const scopeParam = params.get('scope');


      // ========================================================
      // LOGIN CORPORATIVO
      // URL:
      // /account/login?scope=corporate
      // ========================================================

      if (scopeParam === 'corporate') {

        this.scope = 'corporate';

        this.locationId = null;

        console.log('================================');
        console.log('LOGIN CORPORATIVO');
        console.log('scope:', this.scope);
        console.log('locationId:', this.locationId);
        console.log('================================');

        // En corporativo no necesitamos
        // obtener configuración de una ubicación
        this.initLoginForm();

        this.cargando = false;

        return;
      }


      // ========================================================
      // LOGIN POR UBICACIÓN
      // URL:
      // /account/login?locationId=1
      // ========================================================

      if (locationIdParam) {

        this.scope = 'location';

        this.locationId = Number(locationIdParam);

        console.log('================================');
        console.log('LOGIN UBICACIÓN');
        console.log('scope:', this.scope);
        console.log('locationId:', this.locationId);
        console.log('================================');


        // Obtener configuración de la ubicación
        this.getSettings(this.locationId);


        // Crear formulario
        this.initLoginForm();

        return;
      }


      // ========================================================
      // NO EXISTE CONTEXTO
      // ========================================================

      console.warn(
        'No se recibió locationId ni scope=corporate'
      );

      this.router.navigateByUrl('/locations');

    });


    // ==========================================================
    // VALIDAR TOKEN EXISTENTE
    // ==========================================================

    const token = localStorage.getItem('token');


    if (token) {

      this.userService.validarToken().subscribe({

        next: (estaAutenticado: boolean) => {

          if (estaAutenticado) {

            const scope =
              localStorage.getItem('scope');


            // ================================================
            // SESIÓN CORPORATIVA
            // ================================================

            if (scope === 'corporate') {

              this.router.navigateByUrl(
                '/corporate/dashboard'
              );

              return;
            }


            // ================================================
            // SESIÓN DE UBICACIÓN
            // ================================================

            this.router.navigateByUrl(
              '/locations'
            );

          } else {

            // Token inválido
            this.cargando = false;

          }

        },

        error: (error) => {

          console.error(
            'Error validando token:',
            error
          );

          this.cargando = false;

        }

      });

    } else {

      this.cargando = false;

    }


    // ==========================================================
    // BODY
    // ==========================================================

    document.body.classList.add(
      'auth-body-bg'
    );

  }

  private initLoginForm(): void {

    this.loginForm = this.formBuilder.group({

      email: [
        'alberto.najera@mbqinc.com',
        [
          Validators.required,
          Validators.email
        ]
      ],

      password: [
        'T3xNOV@25',
        [
          Validators.required
        ]
      ],

      locationId: [
        this.locationId
      ],

      scope: [
        this.scope
      ]

    });


    // ============================================
    // LOGO
    // ============================================

    if (
      this.logo_img &&
      this.logo_img.toLowerCase().includes('blanco')
    ) {

      this.isWhiteLogo = true;

    }

  }
  onLogoLoaded(): void {
    this.logoLoaded = true;
  }

  onLogoError(): void {
    // Si quieres permitir el login aunque el logo falle:
    this.logoLoaded = true;
  }


  carouselOption: OwlOptions = {
    items: 1,
    loop: false,
    margin: 0,
    nav: false,
    dots: true,
    responsive: {
      680: {
        items: 1
      },
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  /**
   * Form submit
   */
  async onSubmit() {

    const geoip: any = await this.userService.geoip;

    const publicip: any = await this.userService.publicip;


    if (this.loginForm.invalid) {
      this.submitted = true;
      return;
    }
    if (!this.logoLoaded || this.loading) {
      return;
    }

    const is_valid: any = await this.validSession();

    if (!is_valid.ok) {
      Swal.fire('Error', is_valid.msg, 'error');
      return;
    }

    this.isLoading = true;
    this.button = 'Cargando';

    this.userService.login(this.loginForm.value)
      .subscribe({

        next: async (resp: any) => {
          this.loading = false;
          if (resp.ok) {

            if (resp.user.is_new && this.session == '1') {

              this.userService
                .generateToken(resp.token)
                .subscribe((resp1: any) => {

                  this.router.navigate([
                    '/account/password-reset',
                    resp1.token
                  ]);

                });

              return;
            }

            this.router.navigate(['/dashboard']);
            this.inactivityService.startWatching();
            const id = resp.user.id;

            localStorage.setItem(
              'key_id',
              Encrypt(id.toString())
            );

            let msg;

            if (resp.msg) {
              msg = resp.msg;
            } else {
              msg = 'Inicio correcto';
            }

            const navegator = detectBrowserName();

            const data = {

              user_id: resp.user.id,

              msg,

              petition: 'POST',

              detail: 'Acceso exitoso',

              register_id: resp.user.id,

              navegator,

              is_login: '1',

              ip_origin: geoip.ip,

              disconnection: '0',

              ipv6: geoip.version,

              ip: geoip.ip,

              network: geoip.connection.domain,

              city: geoip.city,

              latitude: geoip.latitude,

              longitude: geoip.longitude,

              region: geoip.region,

              timezone: geoip.timezone.id,

              postal: geoip.timezone.postal,

              status_id: 1

            };

            // LOG EXISTENTE

            this.savelog(data);

            // EVENTO EXISTENTE

            this.eventosService.bitacora.fechaHoraEvento = moment();
            this.eventosService.bitacora.usuarioresponsable =
              `${resp.user.name} ${resp.user.lastname}`;

            this.eventosService.bitacora.tiopevento = '5';

            this.eventosService.bitacora.month =
              moment().format('YYYY-MM');

            this.eventosService.bitacora.descripcionevento =
              `Inicio de sesion correcto del usuario ${resp.user.name} ${resp.user.lastname}`;

            this.eventosService.registrarEventos();

            // NUEVA AUDITORIA

            this.auditService.registrar({

              roleName:
                resp.user.profile || 'User',

              responsibleUser:
                `${resp.user.name} ${resp.user.lastname}`,

              actionName: 'LOGIN',

              moduleName: 'AUTH',

              movement:
                `Inicio de sesión exitoso para ${resp.user.email}`,

              urlEndpoint: '/auth/login',

              ipAddress: geoip.ip,

              statusName: 'CORRECTO',

              newData: JSON.stringify({

                userId:
                  resp.user.id,

                email:
                  resp.user.email,

                city:
                  geoip.city,

                region:
                  geoip.region,

                ip:
                  geoip.ip,

                browser:
                  navegator

              }),

              createdBy:
                `${resp.user.name} ${resp.user.lastname}`

            });

          } else {

            setTimeout(() => {

              this.error =
                'Error en la contraseña y/o usuario';

              this.showerror = true;

            }, 6000);

            setTimeout(() => {

              this.showerror = false;

            }, 10000);

            const navegator = detectBrowserName();

            const data = {

              user_id: '',

              msg: resp.msg,

              petition: 'POST',

              detail:
                this.loginForm.get('email').value,

              register_id: '',

              navegator,

              is_login: 0,

              ip_origin: geoip.ip,

              disconnection: 0,

              ipv6: geoip.version,

              ip: geoip.ip,

              network: geoip.network,

              city: geoip.city,

              latitude: geoip.latitude,

              longitude: geoip.longitude,

              region: geoip.region,

              timezone: geoip.timezone,

              postal: geoip.postal,

              status_id: 2

            };

            this.savelog(data);

            this.eventosService.bitacora.fechaHoraEvento =
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

            this.eventosService.bitacora.usuarioresponsable =
              'System';

            this.eventosService.bitacora.tiopevento =
              '5';

            this.eventosService.bitacora.month =
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

            this.eventosService.bitacora.descripcionevento =
              `Registro de alarma - ${resp.msg} ${this.loginForm.get('email').value}`;

            this.eventosService.registrarEventos();

            this.saveAlarma(
              `${resp.msg} - ${this.loginForm.get('email').value}`
            );

            // AUDITORIA LOGIN FALLIDO

            this.auditService.registrar({

              roleName: 'Anonymous',

              responsibleUser:
                this.loginForm.get('email').value,

              actionName: 'LOGIN',

              moduleName: 'AUTH',

              movement:
                `Intento fallido de inicio de sesión para ${this.loginForm.get('email').value}`,

              urlEndpoint: '/auth/login',

              ipAddress: geoip.ip,

              statusName: 'ERROR',

              newData: JSON.stringify({

                email:
                  this.loginForm.get('email').value,

                message:
                  resp.msg,

                city:
                  geoip.city,

                region:
                  geoip.region,

                ip:
                  geoip.ip,

                browser:
                  navegator

              }),

              createdBy:
                this.loginForm.get('email').value

            });

          }

        },

        error: (err) => {
          this.loading = false;
          this.auditService.registrar({

            roleName: 'Anonymous',

            responsibleUser:
              this.loginForm.get('email').value || 'Unknown',

            actionName: 'LOGIN',

            moduleName: 'AUTH',

            movement:
              'Error interno durante el inicio de sesión',

            urlEndpoint: '/auth/login',

            ipAddress:
              geoip?.ip || '',

            statusName: 'ERROR',

            newData: JSON.stringify({

              email:
                this.loginForm.get('email').value,

              error:
                err.error || err.message

            }),

            createdBy:
              this.loginForm.get('email').value || 'System'

          });

          console.error(err);

        }

      });

    setTimeout(() => {

      this.isLoading = false;
      this.button = 'Iniciar Sesión';

    }, 5000);

  }

  async onSubmitCorporate() {

    if (this.loginForm.invalid) {

      this.submitted = true;

      return;

    }


    this.isLoading = true;

    this.button = 'Cargando';


    this.userService
      .loginCorporate(
        this.loginForm.value
      )
      .subscribe({

        next: (resp: any) => {

          this.isLoading = false;
        console.log(resp);
          this.button =
            'Iniciar Sesión';


          if (!resp.ok) {

            this.error =
                'Error en la contraseña y/o usuario';

              this.showerror = true;

            return;

          }


          // =============================================
          // GUARDAR TOKEN
          // =============================================

          localStorage.setItem(
            'token',
            resp.token
          );


          localStorage.setItem(
            'scope',
            'corporate'
          );


          localStorage.removeItem(
            'locationId'
          );


          // =============================================
          // ID USUARIO
          // =============================================

          localStorage.setItem(
            'key_id',
            Encrypt(
              resp.user.id.toString()
            )
          );


          // =============================================
          // DASHBOARD CORPORATIVO
          // =============================================

          console.log(resp);
      if(resp.user.type === 'M'){
         this.router.navigate([
          '/movil/dashboard-movil'
        ]);
      }else{
      
        this.router.navigate([
          '/corporate/dashboard'
        ]);
      }


          // =============================================
          // INACTIVIDAD
          // =============================================

          this.inactivityService
            .startWatching();

        },

        error: (err) => {

          this.isLoading = false;

          this.button =
            'Iniciar Sesión';


          console.error(
            err
          );


        this.error =
                'Error en la contraseña y/o usuario';

              this.showerror = true;

        }

      });

  }

  savelog(resep: any) {
    this.logService.postLogs(resep);
  }


  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  async validSession() {
    return new Promise((resolve, reject) => {
      this.userService.validSesion().subscribe((resp: any) => {

        if (resp.ok) {

          resolve(resp)

        } else {

          resolve(resp)

        }

      });
    });
  }
  getSettings(locationId?: number) {
    this.cargando = true;
    this.settingsService.getSettingsImageLogo(locationId).then((resp: any) => {
      //  
      this.logo_img = resp.imag;
      this.session = resp.session;
      setTimeout(() => {
        this.cargando = false;
      }, 5000);

    })
  }
  saveAlarma(description: any) {
    let dt = moment(new Date())
    let body = {
      fechaHoraEvento: dt.format('yyyy-MM-DDThh:mm:ss'),
      usuarioresponsable: 'System',
      tiopevento: 20,
      month: dt.format('yyyy-MM'),
      descripcionevento: description,
      identificacioncomponentealarma: 'Rechazos de inicio de sesión',
      type: 'alarmas',
    }
    // 
    this.eventosService.alrmaInicio(body).subscribe(resp => { });
  }

  submitLogin(){
     if (this.scope === 'corporate') {

        this.onSubmitCorporate();

        return;
    }

    this.onSubmit();
  }
}
